import React, { useEffect, useState } from "react" 
import { Button } from "../../components/Button" 
import { Drawer } from "../../components/Drawer" 
import { Hairline } from "../../components/Hairline" 
import { Select } from "../../components/Select" 
import styles from "../../../styles/orders.module.scss" 

const months = [
  { value: "1", label: "Janeiro" },
  { value: "2", label: "Fevereiro" },
  { value: "3", label: "Março" },
  { value: "4", label: "Abril" },
  { value: "5", label: "Maio" },
  { value: "6", label: "Junho" },
  { value: "7", label: "Julho" },
  { value: "8", label: "Agosto" },
  { value: "9", label: "Setembro" },
  { value: "10", label: "Outubro" },
  { value: "11", label: "Novembro" },
  { value: "12", label: "Dezembro" },
]

const OrderFilterByDate = ({ openFilter, closeDrawer, callback }) => {
  const [rangeDateType, setRangeDateType] = useState("fromBegin")
  const [beginDate, setBeginDate] = useState({
    hour: "00:00",
    day: new Date().getDate().toString(),
    month: new Date().getMonth() + 1,
    year: new Date().getFullYear().toString(),
  })
  const [endDate, setEndDate] = useState({
    hour: "23:00",
    day: new Date().getDate().toString(),
    month: new Date().getMonth() + 1,
    year: new Date().getFullYear().toString(),
  })
  const [hours, setHours] = useState([]) 
  const [days, setDays] = useState([]) 
  const [years, setYears] = useState([]) 

  useEffect(() => {
    setHoursDaysYears() 
  }, []) 

  const setHoursDaysYears = () => {
    const hours = [] 
    let days = [] 
    const years = [] 

    for (let hour = 0; hour <= 23; hour++) {
      hour = hour <= 9 ? `0${hour}` : hour
      hours.push({ value: `${hour}:00`, label: `${hour}:00` })
    }

    for (let day = 1; day <= 31; day++) {
      days.push({ value: day, label: day })
    }

    const currentYear = (new Date()).getFullYear();
    for (let year = 2018; year <= currentYear; year++) {
      years.unshift({ value: year, label: year })
    }

    setHours(hours) 
    setDays(days) 
    setYears(years) 
  } 

  const handleBeginDate = async (field, e) => {
    const value = e.target.value 
    setBeginDate({ ...beginDate, [field]: value }) 
  } 

  const handleEndDate = async (field, e) => {
    const value = e.target.value 
    setEndDate({ ...endDate, [field]: value }) 
  } 

  const filterBydate = async () => {
    let begin 
    let end 
    if (rangeDateType === "fromBegin") {
      begin = new Date(`1900-01-01 00:00`) 
      end = new Date() 
    }
    if (rangeDateType === "specificDay") {
      begin = new Date(
        `${beginDate.year}-${beginDate.month}-${beginDate.day} 00:00`
      ) 
      end = new Date(
        `${beginDate.year}-${beginDate.month}-${beginDate.day} 23:59`
      ) 
    }
    if (rangeDateType === "specificMonth") {
      begin = new Date(`${beginDate.year}-${beginDate.month}-01 00:00`) 
      end = new Date(`${beginDate.year}-${beginDate.month}-31 23:59`) 
    }
    if (rangeDateType === "specificYear") {
      begin = new Date(`${beginDate.year}-01-01 00:00`) 
      end = new Date(`${beginDate.year}-12-31 23:59`) 
    }
    if (rangeDateType === "custom") {
      begin = new Date(
        `${beginDate.year}-${beginDate.month}-${beginDate.day} ${beginDate.hour}`
      ) 
      end = new Date(
        `${endDate.year}-${endDate.month}-${endDate.day} ${endDate.hour}`
      ) 
    }

    callback(begin.toISOString(), end.toISOString()) 
    closeDrawer() 
  } 

  return (
    <Drawer
      visible={openFilter}
      title="Filtrar"
      footer={
        <Button
        design="primary"
        className="w-100"
        onClick={filterBydate}
      >
          Filtrar período
        </Button>
      }
      onClose={closeDrawer}
    >
      <Select
        label="Intervalo"
        value={rangeDateType}
        options={[
          { value: "fromBegin", label: "Desde o início" },
          { value: "specificDay", label: "Dia específico" },
          { value: "specificMonth", label: "Mês específico" },
          { value: "specificYear", label: "Ano específico" },
          { value: "custom", label: "Intervalo personalizado" },
        ]}
        onChange={(e) => {
          setRangeDateType(e.target.value) 
        }}
      />
      <div className="mt-30 d-flex">
        {rangeDateType === "specificDay" ? (
          <>
            <Select
              value={beginDate.day}
              onChange={(e) => handleBeginDate("day", e)}
              label="Dia"
              className="flex-1 mr-10"
              options={days}
            />
            <Select
              value={beginDate.month}
              onChange={(e) => handleBeginDate("month", e)}
              label="Mês"
              className="flex-1 mr-10"
              options={months}
            />
            <Select
              value={beginDate.year}
              onChange={(e) => handleBeginDate("year", e)}
              label="Ano"
              className="flex-1"
              options={years}
            />
          </>
        ) : (
          ""
        )}
        {rangeDateType === "specificMonth" ? (
          <>
            <Select
              value={beginDate.month}
              onChange={(e) => handleBeginDate("month", e)}
              label="Mês"
              className="flex-1 mr-10"
              options={months}
            />
            <Select
              value={beginDate.year}
              onChange={(e) => handleBeginDate("year", e)}
              label="Ano"
              className="flex-1"
              options={years}
            />
          </>
        ) : (
          ""
        )}
        {rangeDateType === "specificYear" ? (
          <>
            <Select
              value={beginDate.year}
              onChange={(e) => handleBeginDate("year", e)}
              label="Ano"
              className="flex-1"
              options={years}
            />
          </>
        ) : (
          ""
        )}
        {rangeDateType === "custom" ? (
          <div className="d-flex flex-column flex-1">
            <Hairline />
            <span className={styles.ordersCustomFilterTitle}>
              Início do intervalo em:
            </span>

            <div className="d-flex mt-20">
              <Select
                value={beginDate.month}
                onChange={(e) => handleBeginDate("month", e)}
                label="Mês"
                className="flex-1 mr-10"
                options={months}
              />
              <Select
                value={beginDate.year}
                onChange={(e) => handleBeginDate("year", e)}
                label="Ano"
                className="flex-1"
                options={years}
              />
            </div>

            <div className="d-flex mt-20">
              <Select
                value={beginDate.day}
                onChange={(e) => handleBeginDate("day", e)}
                label="Dia"
                className="flex-1 mr-10"
                options={days}
              />
              <Select
                defaultValue="00:00"
                onChange={(e) => handleBeginDate("hour", e)}
                label="Hora"
                className="flex-1"
                options={hours}
              />
            </div>

            <Hairline />
            <span className={styles.ordersCustomFilterTitle}>
              Final do intervalo em:
            </span>

            <div className="d-flex mt-20">
              <Select
                value={endDate.month}
                onChange={(e) => handleEndDate("month", e)}
                label="Mês"
                className="flex-1 mr-10"
                options={months}
              />
              <Select
                value={endDate.year}
                onChange={(e) => handleEndDate("year", e)}
                label="Ano"
                className="flex-1"
                options={years}
              />
            </div>

            <div className="d-flex mt-20">
              <Select
                value={endDate.day}
                onChange={(e) => handleEndDate("day", e)}
                label="Dia"
                className="flex-1 mr-10"
                options={days}
              />
              <Select
                defaultValue="23:00"
                onChange={(e) => handleEndDate("hour", e)}
                label="Hora"
                className="flex-1"
                options={hours}
              />
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
      
    </Drawer>
  ) 
} 

export default OrderFilterByDate 